module.exports = __webpack_public_path__ + "media/img/apple-icon-60x60-8717ca372a3f08354aae7b494527b7d9.png";